module.exports = __webpack_public_path__ + "img/facebook2.13afd1e3.svg";